import { ApiClient } from "@ucl/library";
import { UnderwritingRuleResultUpdateDTO, ResultType } from "@/types/UnderwritingRuleResultUpdateDTO";

export interface UnderwritingRuleResultReadDTO {
  id: string;
  resultType: ResultType | null;
  resultComment: string | null;
  parentEntityType: string;
  parentEntityId: string;
  entityType: string;
  entityId: string;
  entityDisplayName: string;
  productApplicationId: string | null;
  underwritingRuleId: string;
  // Additional fields from the rule
  ruleFriendlyId: string;
  ruleDescription: string;
  productName: string | null;
  createdBy: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
  isDeleted: boolean;
}

class UnderwritingRuleResultsApiClient {
  private _apiClient: ApiClient;

  constructor(apiClient: ApiClient) {
    this._apiClient = apiClient;
  }

  getRuleResultIdsByParentEntity = async (parentEntityType: string, parentEntityId: string) => {
    return this._apiClient.get<string[]>(
      `/api/underwriting-rule-results/by-parent-entity?parentEntityType=${encodeURIComponent(parentEntityType)}&parentEntityId=${encodeURIComponent(parentEntityId)}`
    );
  };

  getRuleResultById = async (ruleResultId: string) => {
    return this._apiClient.get<UnderwritingRuleResultReadDTO>(`/api/underwriting-rule-results/${ruleResultId}`);
  };

  updateRuleResult = async (ruleResultId: string, updateData: UnderwritingRuleResultUpdateDTO) => {
    return this._apiClient.put<UnderwritingRuleResultReadDTO>(`/api/underwriting-rule-results/${ruleResultId}`, updateData);
  };

  runRules = async (parentEntityType: string, parentEntityId: string) => {
    return this._apiClient.post(`/api/underwriting-rule-results/run-rules?parentEntityType=${encodeURIComponent(parentEntityType)}&parentEntityId=${encodeURIComponent(parentEntityId)}`);
  };
}

export default UnderwritingRuleResultsApiClient;
